import { SignIn } from 'containers/Auth'

export default SignIn
